import {
    ABSENTEE_BID_SUCCESS,
    ABSENTEE_BID_SUCCESS_ACTION,
    LIVE_BID_ACCEPTED,
    LIVE_BID_ACCEPTED_ACTION,
    LIVE_BID_RETRACTED,
    LIVE_BID_RETRACTED_ACTION,
    LIVE_LOT_PASSED,
    LIVE_LOT_PASSED_ACTION,
    LIVE_LOT_REOPENED,
    LIVE_LOT_REOPENED_ACTION,
    LIVE_LOT_SOLD,
    LIVE_LOT_SOLD_ACTION,
    LIVE_LOT_UNSOLD,
    LIVE_LOT_UNSOLD_ACTION,
    LIVE_NEXT_LOT_LOADED,
    LIVE_NEXT_LOT_LOADED_ACTION,
    LOAD_BIDDER_BIDDING_ALL_SUCCESS,
    LOAD_BIDDER_DATA_SUCCESS,
    LOAD_CATALOG_AD_SUCCESS,
    LOAD_CATALOG_ITEM_MODELS_SUCCESS,
    LOAD_CATEGORY_RESULTS_SUCCESS,
    LOAD_HOME_DATA_SUCCESS,
    LOAD_ITEM_CARD_MODELS_FAIL,
    LOAD_ITEM_CARD_MODELS_FAIL_ACTION,
    LOAD_ITEM_CARD_MODELS_REQUEST,
    LOAD_ITEM_CARD_MODELS_REQUEST_ACTION,
    LOAD_ITEM_CARD_MODELS_SUCCESS,
    LOAD_ITEM_CARD_MODELS_SUCCESS_ACTION,
    LOAD_ITEM_DATA_FROM_ELSEWHERE_SUCCESS,
    LOAD_LIVE_CATALOG_STATUS_SUCCESS,
    LOAD_LIVE_CATALOG_STATUS_SUCCESS_ACTION,
    LOAD_PROMOTED_SEARCH_RESULTS_SUCCESS,
    LOAD_SAVED_ITEMS_SUCCESS,
    LOAD_SEARCH_RESULTS_SUCCESS,
    LOAD_SIMILAR_ITEMS_SUCCESS,
    LOAD_SIMILAR_SOLD_ITEMS_SUCCESS,
    LOAD_STOREFRONT_ITEMS_SUCCESS,
    LOG_OUT_BIDDER,
    LOGIN_SUCCESS,
    RETRACT_BID_SUCCESS,
    RETRACT_BID_SUCCESS_ACTION,
} from './actions';
import { combineActions, handleActions } from 'redux-actions';
import { emptyDefaultItemCardModel, ItemCardModel } from '@/types/ItemCardModel';
import api from '@/redux/api/itemCardModel';
import chunk from 'lodash/chunk';
import cloneDeep from 'lodash/cloneDeep';
import { createSelector } from 'reselect';
import difference from 'lodash/difference';
import { EmptyBiddingInfo } from '@/types/BiddingInfo';
import { EmptyBuyNow } from '@/types/BuyNow';
import { EmptyCatalog } from '@/types/Catalog';
import { EmptySeller } from '@/types/Seller';
import { filterItemSearch } from './sorting';
import { getAuthToken } from '@/redux/modules/user';
import { getDeployment } from '@/redux/modules/config';
import { GlobalState } from '../rootReducer';
import ms from 'ms';
import { safelyEscapeText } from '@/utils/safelyRender';
import union from 'lodash/union';

const REDUX_STORE_TIME = ms('5m');
const FETCH_SET_SIZE = 400;

export type State = {
    readonly byId: {
        [itemId: number]: ItemCardModel;
    };
    readonly loaded: {
        [itemId: number]: number;
    };
    readonly loading: number[];
};

export const DEFAULT_STATE: State = {
    byId: {},
    loaded: {},
    loading: [],
};

export default handleActions(
    {
        // HANDLE LOGIN for updating the bidding info portion
        // handle userdata fro updating the bidding info
        [ABSENTEE_BID_SUCCESS]: (state: State, action: ABSENTEE_BID_SUCCESS_ACTION): State => {
            const { isReserveMet, leadingBid } = action.payload;
            const existingItem = cloneDeep(state.byId[action.meta.itemId]);

            existingItem.bidActivityCount = !existingItem.bidderHasHighBid
                ? existingItem.bidActivityCount + 1
                : existingItem.bidActivityCount;
            existingItem.bidderBidTimestamp = action.meta.actionTime;
            existingItem.bidderHasBid = true;
            existingItem.bidderHasHighBid = action.payload.isCurrentHighBid;
            existingItem.bidderMaxBid = Number(action.payload.currentBid);
            existingItem.leadingBid = leadingBid;
            existingItem.isReserveMet = isReserveMet;

            return {
                ...state,
                byId: { ...state.byId, [action.meta.itemId]: existingItem },
            };
        },
        [LIVE_LOT_PASSED]: (state: State, action: LIVE_LOT_PASSED_ACTION): State => {
            const itemId = action.payload.itemId;
            const existingItem = cloneDeep(state.byId[itemId] || emptyDefaultItemCardModel);

            existingItem.isSold = false;
            existingItem.isAvailable = false;
            existingItem.isLocked = true;
            existingItem.isPassed = true;

            return {
                ...state,
                byId: { ...state.byId, [itemId]: existingItem },
            };
        },
        [LIVE_LOT_REOPENED]: (state: State, action: LIVE_LOT_REOPENED_ACTION): State => {
            const itemId = action.payload.itemId;
            const existingItem = cloneDeep(state.byId[itemId] || emptyDefaultItemCardModel);

            existingItem.salePrice = 0;
            existingItem.isSold = false;
            existingItem.isAvailable = true;
            existingItem.isPassed = false;

            return {
                ...state,
                byId: { ...state.byId, [itemId]: existingItem },
            };
        },
        [LIVE_LOT_SOLD]: (state: State, action: LIVE_LOT_SOLD_ACTION): State => {
            const itemId = action.payload.itemId;
            const existingItem = cloneDeep(state.byId[itemId] || emptyDefaultItemCardModel);

            existingItem.bidderHasBid = action.payload.myBid ? true : existingItem.bidderHasBid;
            existingItem.bidderHasHighBid = action.payload.myBid;
            existingItem.isAvailable = false;
            existingItem.isLocked = true;
            existingItem.isPassed = false;
            existingItem.isSold = true;
            existingItem.leadingBid = action.payload.amount;
            existingItem.salePrice = action.payload.amount;

            return {
                ...state,
                byId: { ...state.byId, [itemId]: existingItem },
            };
        },
        [LIVE_LOT_UNSOLD]: (state: State, action: LIVE_LOT_UNSOLD_ACTION): State => {
            const itemId = action.payload.itemId;
            const existingItem = cloneDeep(state.byId[itemId] || emptyDefaultItemCardModel);

            existingItem.isSold = false;
            existingItem.isAvailable = false;
            existingItem.isLocked = true;
            existingItem.isPassed = false;

            return {
                ...state,
                byId: { ...state.byId, [itemId]: existingItem },
            };
        },

        [LIVE_NEXT_LOT_LOADED]: (state: State, action: LIVE_NEXT_LOT_LOADED_ACTION): State => {
            const itemId = action.payload.itemId;
            const existingItem = cloneDeep(state.byId[itemId] || emptyDefaultItemCardModel);

            existingItem.isLocked = true;

            return {
                ...state,
                byId: { ...state.byId, [itemId]: existingItem },
            };
        },
        [combineActions(LOAD_BIDDER_DATA_SUCCESS, LOGIN_SUCCESS)]: (state: State, action: any): State => {
            const existing = cloneDeep(state.byId);
            const loaded = { ...state.loaded };

            // TODO: check to see if we really care about any of the items that arent upcoming
            action.payload.biddingInfos.forEach(
                ({
                    bidActivityCount,
                    bidCount,
                    bidderBidTimestamp,
                    bidderHasBid,
                    bidderHasHighBid,
                    bidderMaxBid,
                    isAvailable,
                    isLocked,
                    isPassed,
                    isReserveMet,
                    isSold,
                    itemId,
                    leadingBid,
                    salePrice,
                }) => {
                    existing[itemId] = {
                        ...emptyDefaultItemCardModel,
                        ...existing[itemId],
                        bidActivityCount,
                        bidCount,
                        bidderBidTimestamp,
                        bidderHasBid,
                        bidderHasHighBid,
                        bidderMaxBid,
                        isAvailable,
                        isLocked,
                        isPassed,
                        isReserveMet,
                        isSold,
                        itemId,
                        leadingBid,
                        salePrice,
                    };
                    loaded[itemId] = action.meta.actionTime;
                }
            );

            return {
                ...state,
                byId: existing,
                loaded: loaded,
            };
        },
        [LOAD_BIDDER_BIDDING_ALL_SUCCESS]: (state: State, action: any): State => {
            const existing = cloneDeep(state.byId);
            const loaded = { ...state.loaded };

            [...action.payload.upcomingBidItems, ...action.payload.pastBidItems].forEach(
                ({
                    bidActivityCount,
                    bidCount,
                    bidderBidTimestamp,
                    bidderHasBid,
                    bidderHasHighBid,
                    bidderMaxBid,
                    isAvailable,
                    isLocked,
                    isPassed,
                    isReserveMet,
                    isSold,
                    itemId,
                    leadingBid,
                    salePrice,
                }) => {
                    existing[itemId] = {
                        ...emptyDefaultItemCardModel,
                        ...existing[itemId],
                        bidActivityCount,
                        bidCount,
                        bidderBidTimestamp,
                        bidderHasBid,
                        bidderHasHighBid,
                        bidderMaxBid,
                        bidderWonItem: bidderHasHighBid && isSold,
                        isAvailable,
                        isLocked,
                        isPassed,
                        isReserveMet,
                        isSold,
                        itemId,
                        leadingBid,
                        salePrice,
                    };
                    loaded[itemId] = action.meta.actionTime;
                }
            );

            return {
                ...state,
                byId: existing,
                loaded: loaded,
            };
        },
        [LOAD_CATALOG_AD_SUCCESS]: (state: State, action: LOAD_ITEM_DATA_FROM_ELSEWHERE_SUCCESS): State => {
            const existing = cloneDeep(state.byId);
            const loaded = { ...state.loaded };
            const time = action.meta.actionTime;

            const { catalogs = [], items = [], sellers = [] } = action.payload;

            items.forEach((item) => {
                const catalog = catalogs.find((c) => c.catalogId === item.catalogId);
                const seller = sellers.find((s) => s.sellerId === item.sellerId);

                existing[item.itemId] = {
                    ...emptyDefaultItemCardModel,
                    ...existing[item.itemId],
                    catalogId: item.catalogId,
                    catalogStatus: catalog.catalogStatus,
                    catalogTitle: safelyEscapeText(catalog.title),
                    currency: catalog.currency || 'USD',
                    highBidEstimate: item.highBidEstimate || 0,
                    imageVersion: item.imageVersion,
                    index: 9999, // this is so that we'll be sure to request the rest of the data if necessary
                    isCatalogOnly: catalog.isCatalogOnly,
                    isDeleted: item.isDeleted,
                    isLiveAuction: !catalog.isCatalogOnly && !catalog.isTimed,
                    isSEOExcluded: item.isSEOExcluded,
                    isTimedAuction: catalog.isTimed,
                    itemId: item.itemId,
                    lotNumber: item.lotNumber,
                    lotsListed: catalog.lotsListed,
                    lowBidEstimate: item.lowBidEstimate || 0,
                    photos: item.photos || [],
                    saleStartTs: catalog.saleStartTs,
                    sellerCity: seller.city,
                    sellerCountryCode: seller.countryCode,
                    sellerId: seller.sellerId,
                    sellerLogoId: seller.logoId || '',
                    sellerName: safelyEscapeText(seller.name),
                    sellerStateCode: seller.stateCode,
                    shortDescription: safelyEscapeText(item.descriptionBlurb),
                    startPrice: item.startPrice,
                    title: item.title,
                };

                loaded[item.itemId] = time;
            });

            return {
                ...state,
                byId: existing,
                loaded,
            };
        },
        [LOAD_ITEM_CARD_MODELS_FAIL]: (state: State, action: LOAD_ITEM_CARD_MODELS_FAIL_ACTION): State => ({
            ...state,
            loading: difference(state.loading, action.meta.itemIds),
        }),
        [LOAD_ITEM_CARD_MODELS_REQUEST]: (state: State, action: LOAD_ITEM_CARD_MODELS_REQUEST_ACTION): State => ({
            ...state,
            loading: union(state.loading, action.meta.itemIds),
        }),
        // ALL these actions use the new itemCardModel directly
        [combineActions(
            LOAD_ITEM_CARD_MODELS_SUCCESS,
            LOAD_CATALOG_ITEM_MODELS_SUCCESS,
            LOAD_SAVED_ITEMS_SUCCESS,
            LOAD_SIMILAR_ITEMS_SUCCESS,
            LOAD_SIMILAR_SOLD_ITEMS_SUCCESS
        )]: (state: State, action: LOAD_ITEM_CARD_MODELS_SUCCESS_ACTION): State => {
            const existing = cloneDeep(state.byId);
            const loaded = { ...state.loaded };
            let loading = [...state.loading];
            const time = action.meta.actionTime;

            if (action.payload) {
                action.payload.forEach((item) => {
                    let itemId = item.itemId;
                    existing[itemId] = {
                        ...item,
                        catalogTitle: safelyEscapeText(item.catalogTitle),
                        photos: item.photos || [],
                        sellerName: safelyEscapeText(item.sellerName),
                        shortDescription: safelyEscapeText(item.shortDescription),
                        title: safelyEscapeText(item.title),
                    };
                    loaded[itemId] = time;
                    loading = difference(loading, [itemId]);
                });
            }

            // TODO: Do we cleanup?
            // const now = Date.now();
            // let toCleanup = Object.keys(loaded)
            //     .map((key) => ({ id: key, ts: loaded[key] }))
            //     .filter(({ ts }) => now - ts > REDUX_CLEANUP_LIMIT)
            //     .map(({ id }) => id);
            // existing = omit(existing, toCleanup);
            // loaded = omit(loaded, toCleanup);

            return {
                ...state,
                byId: existing,
                loaded,
                loading,
            };
        },
        [LOAD_LIVE_CATALOG_STATUS_SUCCESS]: (state: State, action: LOAD_LIVE_CATALOG_STATUS_SUCCESS_ACTION): State => {
            // If auction service returns 'notLoaded', we can ignore this action as no other data is returned
            if (action.payload.status !== 'notLoaded') {
                const currentLot = action.payload.currentItem;
                const currentBidder = action.meta.bidderId === currentLot.leadingBidder;
                const itemId = currentLot.itemId;
                const existingItem = cloneDeep(state.byId[itemId] || emptyDefaultItemCardModel);

                existingItem.leadingBid = currentLot.leadingBid;

                if (currentBidder) {
                    existingItem.bidderHasBid = true;
                    existingItem.bidderHasHighBid = true;
                } else {
                    existingItem.bidderHasHighBid = false;
                }

                return {
                    ...state,
                    byId: { ...state.byId, [itemId]: existingItem },
                };
            } else {
                return { ...state };
            }
        },
        [combineActions(
            LOAD_SEARCH_RESULTS_SUCCESS,
            LOAD_CATEGORY_RESULTS_SUCCESS,
            LOAD_PROMOTED_SEARCH_RESULTS_SUCCESS
        )]: (state: State, action: any): State => {
            const existing = cloneDeep(state.byId);
            const loaded = { ...state.loaded };
            let loading = [...state.loading];
            const time = action.meta.actionTime;

            if (action?.payload?.items) {
                action.payload.items.forEach((item) => {
                    let itemId = item.itemId;
                    existing[itemId] = {
                        ...item,
                        catalogTitle: safelyEscapeText(item.catalogTitle),
                        photos: item.photos || [],
                        sellerName: safelyEscapeText(item.sellerName),
                        shortDescription: safelyEscapeText(item.shortDescription),
                        title: safelyEscapeText(item.title),
                    };
                    loaded[itemId] = time;
                    loading = difference(loading, [itemId]);
                });
            }

            return {
                ...state,
                byId: existing,
                loaded,
                loading,
            };
        },
        [LOG_OUT_BIDDER]: (state: State): State => {
            const existing = cloneDeep(state.byId);

            Object.keys(existing).forEach((key) => {
                const item = existing[key];
                item.bidderBidTimestamp = 0;
                item.bidderHasBid = false;
                item.bidderHasHighBid = false;
                item.bidderMaxBid = 0;
                item.bidderWonItem = false;
            });

            return {
                ...state,
                byId: existing,
            };
        },

        [combineActions(LOAD_HOME_DATA_SUCCESS, LOAD_STOREFRONT_ITEMS_SUCCESS)]: (
            state: State,
            action: LOAD_ITEM_DATA_FROM_ELSEWHERE_SUCCESS
        ): State => {
            const existing = cloneDeep(state.byId);
            const loaded = { ...state.loaded };
            const time = action.meta.actionTime;

            const { biddingInfos = [], buyNows = [], catalogs = [], items = [], sellers = [] } = action.payload;

            items.forEach((item) => {
                const catalog = catalogs.find((c) => c.catalogId === item.catalogId) || EmptyCatalog;
                const seller = sellers.find((s) => s.sellerId === item.sellerId) || EmptySeller;
                const buyNow = buyNows.find((i) => i.itemId === item.itemId) || EmptyBuyNow;
                const biddingInfo = biddingInfos.find((i) => i.itemId === item.itemId) || EmptyBiddingInfo;

                existing[item.itemId] = {
                    ...emptyDefaultItemCardModel,
                    ...existing[item.itemId],
                    bidActivityCount: biddingInfo.bidActivityCount || 0,
                    bidCount: biddingInfo.bidCount || 0,
                    bidderBidTimestamp: biddingInfo.bidderBidTimestamp,
                    bidderHasBid: biddingInfo.bidderHasBid,
                    bidderHasHighBid: biddingInfo.bidderHasHighBid,
                    bidderMaxBid: biddingInfo.bidderMaxBid,
                    bidderWonItem: biddingInfo.bidderHasHighBid && biddingInfo.isSold,
                    buyNowPrice: buyNow.price,
                    buyNowStatus: buyNow.status === 'available' ? 1 : 0,
                    catalogId: item.catalogId,
                    catalogStatus: catalog.catalogStatus,
                    catalogTitle: safelyEscapeText(catalog.title),
                    currency: catalog.currency || 'USD',
                    highBidEstimate: item.highBidEstimate || 0,
                    imageVersion: item.imageVersion,
                    index: item.index,
                    isAvailable: biddingInfo.isAvailable,
                    isCatalogOnly: catalog.isCatalogOnly,
                    isDeleted: item.isDeleted,
                    isLiveAuction: !catalog.isCatalogOnly && !catalog.isTimed,
                    isLocked: biddingInfo.isLocked,
                    isPassed: biddingInfo.isPassed,
                    isReserveMet: biddingInfo.isReserveMet,
                    isSEOExcluded: item.isSEOExcluded,
                    isSold: biddingInfo.isSold,
                    isTimedAuction: catalog.isTimed,
                    itemId: item.itemId,
                    leadingBid: biddingInfo.leadingBid,
                    lotNumber: item.lotNumber,
                    lotsListed: catalog.lotsListed,
                    lowBidEstimate: item.lowBidEstimate || 0,
                    photos: item.photos || [],
                    salePrice: biddingInfo.salePrice,
                    saleStartTs: catalog.saleStartTs,
                    sellerCity: seller.city,
                    sellerCountryCode: seller.countryCode,
                    sellerId: seller.sellerId,
                    sellerLogoId: seller.logoId || '',
                    sellerName: safelyEscapeText(seller.name),
                    sellerStateCode: seller.stateCode,
                    shortDescription: safelyEscapeText(item.descriptionBlurb),
                    startPrice: item.startPrice,
                    title: safelyEscapeText(item.title),
                };

                loaded[item.itemId] = time;
            });

            return {
                ...state,
                byId: existing,
                loaded,
            };
        },
        [RETRACT_BID_SUCCESS]: (state: State, action: RETRACT_BID_SUCCESS_ACTION): State => {
            const { payload: retractedItemId } = action;

            const existingItem = cloneDeep(state.byId[retractedItemId] || emptyDefaultItemCardModel);

            existingItem.bidderHasBid = false;
            existingItem.bidderHasHighBid = false;
            existingItem.bidderMaxBid = 0;

            return {
                ...state,
                byId: { ...state.byId, [retractedItemId]: existingItem },
            };
        },
        [combineActions(LIVE_BID_ACCEPTED, LIVE_BID_RETRACTED)]: (
            state: State,
            action: LIVE_BID_ACCEPTED_ACTION | LIVE_BID_RETRACTED_ACTION
        ): State => {
            const itemId = action.payload.itemId;
            const existingItem = cloneDeep(state.byId[itemId] || emptyDefaultItemCardModel);

            existingItem.bidderHasHighBid = action.payload.myBid;
            existingItem.leadingBid = action.payload.amount;

            return {
                ...state,
                byId: { ...state.byId, [itemId]: existingItem },
            };
        },
    },
    DEFAULT_STATE
);

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.itemCardModel;
const idSelector = (state: GlobalState, id: number) => id;
const idSecondSelector = (state: GlobalState, _, id: string) => id;
const idsSelector = (state: GlobalState, ids: number[]) => ids;

const byIdSelector = createSelector(stateSelector, (state: State) => state.byId);
const loadedSelector = createSelector(stateSelector, (state: State) => state.loaded);
const loadingSelector = createSelector(stateSelector, (state: State) => state.loading);

export const getIsItemCardModelLoaded = createSelector([loadedSelector, idSelector], (loaded, id) =>
    loaded.hasOwnProperty(id)
);

export const getAllItemCardModels = createSelector(stateSelector, (state: State) => state.byId);

export const getLoadTimeForItemCardModel = createSelector(
    [loadedSelector, idSelector],
    (loaded, itemId) => loaded[itemId] || 0
);

export const getItemCardModel = createSelector([byIdSelector, idSelector], (byId, itemId) => {
    return byId[itemId] || emptyDefaultItemCardModel;
});

export const getItemCardModels = createSelector([byIdSelector, idsSelector], (byId, itemIds) =>
    (itemIds || []).map((itemId: number) => byId[itemId]).filter((item) => Boolean(item))
);

export const getIsItemCardModelLoading = createSelector([loadingSelector, idSelector], (loading, id) =>
    loading.includes(id)
);

export const getItemIdsForCatalog = createSelector([byIdSelector, idSelector], (byId, id): number[] =>
    Object.keys(byId)
        .map((key) => byId[key])
        .filter((item) => item.catalogId === id)
        .map((item) => item.itemId)
);

export const getItemsForCatalog = createSelector([byIdSelector, idSelector], (byId, id): ItemCardModel[] =>
    Object.keys(byId)
        .map((key) => byId[key])
        .filter((item) => item.catalogId === id)
        .sort((a, b) => a.index - b.index)
);

export const getItemIdsForCatalogWithMostBids = createSelector([byIdSelector, idSelector], (byId, id): number[] =>
    Object.keys(byId)
        .map((key) => byId[key])
        .filter((item) => item.catalogId === id)
        .sort((a, b) => a.bidActivityCount - b.bidActivityCount)
        .map((item) => item.itemId)
        .slice(0, 10)
);

export const getItemIdsForSeller = createSelector([byIdSelector, idSelector], (byId, id): number[] =>
    Object.keys(byId)
        .map((key) => byId[key])
        .filter((item) => item.sellerId === id)
        .map((item) => item.itemId)
);

export const getItemsForCatalogWithSearch = createSelector(
    [byIdSelector, idSelector, idSecondSelector],
    (byId, id, terms): number[] => {
        const items = Object.keys(byId)
            .map((key) => byId[key])
            .filter(({ catalogId }) => catalogId === id)
            .sort((a, b) => a.index - b.index);

        return filterItemSearch(items, terms).map((item) => item.itemId);
    }
);

type NextAndPreviousItemResponse = {
    next: ItemCardModel;
    previous: ItemCardModel;
};

export const getNextAndPreviousItems = createSelector(
    [byIdSelector, idSelector],
    (byId, id): NextAndPreviousItemResponse => {
        const { catalogId, index, lotsListed } = byId[id] || {};

        const items = Object.keys(byId)
            .map((key) => byId[key])
            .filter((item) => item.catalogId === catalogId);

        let previous: ItemCardModel;
        let next: ItemCardModel;

        if (index === 0) {
            next = items.find((item) => item.index === index + 1);
        } else if (index === lotsListed - 1) {
            previous = items.find((item) => item.index === index - 1);
        } else {
            previous = items.find((item) => {
                return item.index === index - 1;
            });
            next = items.find((item) => {
                return item.index === index + 1;
            });
        }

        return { next: next || emptyDefaultItemCardModel, previous: previous || emptyDefaultItemCardModel };
    }
);

const shouldFetchItem = (state: GlobalState, itemId: number): boolean => {
    if (!itemId) {
        return false;
    }
    const item = getItemCardModel(state, itemId);
    // item.index === 9999 indicates that it was loaded from the similar items endpoint and we should refetch
    if (item.itemId && item.index !== 9999 && item.lotsListed) {
        const loaded = getLoadTimeForItemCardModel(state, itemId);
        const time = Date.now();
        const diff = time - loaded;
        const catalogDone = item.catalogStatus === 'done';
        if (diff < REDUX_STORE_TIME || catalogDone) {
            return false;
        }
    }
    const loading = getIsItemCardModelLoading(state, itemId);
    return !loading;
};

const whichItemCardModelsNeeded = (state: GlobalState, itemIds: number[]): number[] =>
    itemIds.filter((itemId) => shouldFetchItem(state, itemId));

const fetchItemCardModels =
    (itemIds: number[], identifier: string) => async (dispatch: Function, getState: Function) => {
        try {
            const state = getState();
            const authToken = getAuthToken(state);
            const deployment = getDeployment(state);
            dispatch({
                meta: { itemIds },
                type: LOAD_ITEM_CARD_MODELS_REQUEST,
            } as LOAD_ITEM_CARD_MODELS_REQUEST_ACTION);

            const { payload } = await api.fetchItemCardModelsByIds({ authToken, deployment, identifier, itemIds });

            return dispatch({
                meta: { actionTime: Date.now() },
                payload: payload.items,
                type: LOAD_ITEM_CARD_MODELS_SUCCESS,
            } as LOAD_ITEM_CARD_MODELS_SUCCESS_ACTION);
        } catch (error) {
            return dispatch({
                error: true,
                meta: { itemIds },
                payload: error,
                type: LOAD_ITEM_CARD_MODELS_FAIL,
            } as LOAD_ITEM_CARD_MODELS_FAIL_ACTION);
        }
    };

export const fetchItemCardModelIfNeeded =
    (itemId: number, identifier: string, force?: boolean) => async (dispatch: Function, getState: Function) => {
        if (force || shouldFetchItem(getState(), itemId)) {
            return dispatch(fetchItemCardModels([itemId], identifier));
        }

        return Promise.resolve();
    };

export const fetchItemCardModelsIfNeeded =
    (itemIds: number[], identifier: string, force?: boolean) => async (dispatch: Function, getState: Function) => {
        const needed = force ? itemIds : whichItemCardModelsNeeded(getState(), itemIds);
        if (Boolean(needed.length)) {
            // If the array of items is too long we wont be able to send it.
            // We'll chunk it up into blocks of 400 that we can request separately
            if (needed.length > FETCH_SET_SIZE) {
                const chunks = chunk(needed, FETCH_SET_SIZE);
                const promises = chunks.map((chunk) => dispatch(fetchItemCardModels(chunk, identifier)));
                return Promise.all(promises);
            }
            return dispatch(fetchItemCardModels(needed, identifier));
        }
        return Promise.resolve();
    };
